<template>
  <div>
    <div class="text-h4 ma-1 ma-sm-6">{{ title }}</div>
    <div v-if="loading">Loading . . .</div>
    <div v-if="items" class="ma-1 ma-sm-6">
      <div class="my-3">
        <v-btn-toggle
          v-model="typeIndex"
          rounded
          mandatory
          v-if="route == 'MedIngredients'"
          active-class="orangeActive"
          class="toggleBtns"
        >
          <v-btn small :val="1">
            <v-img
              src="https://www.eyedock.com/images/icons/meds/small_rx_icon.svg"
              width="20"
              contain
              eager
              class="mr-2"
            />
            Medications</v-btn
          >
          <v-btn small :val="0">
            <v-img
              src="https://www.eyedock.com/images/icons/meds/small_drop_icon.svg"
              width="20"
              contain
              eager
              class="mr-2"
            />
            Lubricants</v-btn
          >
        </v-btn-toggle>
      </div>

      <div class="">
        <div
          v-for="(categoryArr, categoryName) in selectedMeds"
          :key="categoryName"
          class="mt-2 categorySection d-flex flex-column"
        >
          <div>
            <div class="text-h5 categoryTitle my-3 py-1 px-2">
              <!-- {{ deSlug(categoryName) }} -->
              {{ categoryArr.meta.name }}
            </div>

            <!-- <p>{{ categoryItems }}</p> -->
            <div class="ma-4">
              <div
                v-for="(
                  subcategoryArr, subcategoryName
                ) in categoryArr.subcategories"
                :key="subcategoryName"
                class="my-6"
              >
                <span
                  v-if="subcategoryArr.meta.code != '-'"
                  class="overline text-decoration-underline mt-2"
                >
                  <!-- {{ deSlug(category2Name)  }} -->
                  {{ subcategoryArr.meta.name }}
                </span>

                <div class="d-flex flex-row flex-wrap">
                  <div
                    v-for="(item, index) in subcategoryArr.items"
                    :key="index"
                    class="drugDiv"
                  >
                    <v-btn
                      text
                      color="blue"
                      @click="doRoute(item.id, item.name)"
                      >{{ item.name | truncate(35) }}</v-btn
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiServices from "@/services/ApiServices";
import Slugify from "slugify";
// import MedIngredientDetailModal from "../components/MedIngredientDetailModal";

// import Name from "../dir/file";

export default {
  components: {},
  name: "MedIngredients",
  //   components: { MedIngredientDetailModal },
  props: {},
  data: function () {
    return {
      items: null,
      loading: false,
      typeIndex: 0,
      route: null, // will be ingredient or moa
    };
  },
  methods: {
    slugText(name) {
      return Slugify(name.toLowerCase());
    },

    deSlug(str) {
      return str.replace(/_/g, " ");
    },
    doRoute(id, name) {
      let url = `/meds/${this.linkPath}/${id}/${this.slugText(name)}`;
      this.$router.push({ path: url });
    },
  },
  computed: {
    selectedMeds: function () {
      if (!this.items) return null;
      return this.typeIndex == 0 ? this.items.meds : this.items.lubricants;
    },

    title: function () {
      let temp = "";
      if (this.route == "MedMoas") return "Methods of Action";
      if (this.route == "MedIngredients") return "Ingredients";
      return temp;
    },
    apiRoute: function () {
      let temp = null;
      if (this.route == "MedMoas") return "/meds/moas";
      if (this.route == "MedIngredients") return "/meds/ingredients";
      return temp;
    },
    linkPath: function () {
      let temp = null;
      if (this.route == "MedMoas") return "moa";
      if (this.route == "MedIngredients") return "ingredient";
      return temp;
    },
  },
  mounted: function () {
    // note the route name (from router/index.js) needs to be the same as the apiservices, medMoas or medIngredients
    this.route = this.$route.name;
    let apiFunc = this.apiRoute;
    if (!apiFunc) return; // todo - show an error message?
    this.loading = true;
    ApiServices.genericApiCall(apiFunc)
      .then((response) => {
        this.items = response.data;
        this.loading = false;
      })
      .catch((error) => {
        console.log(error);
        this.loading = false;
      });
    //console.log(window.location.ingredient);
  },
  metaInfo() {
    return {
      title: "EyeDock/Meds | Browse Ingredients",
    };
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
.categoryTitle {
  background-color: #ffebc9;
  text-transform: capitalize;
  border-radius: 2px;
}
.drugDiv {
  width: 360px;
  text-overflow: ellipsis;
}
</style>
